import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function FacebookMonoIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 20 20" {...props}>
      <Box
        as="path"
        fill="currentColor"
        d="M20 10c0-5.523-4.477-10-10-10S0 4.477 0 10c0 4.689 3.229 8.624 7.584 9.705v-6.65H5.522V10h2.062V8.683c0-3.404 1.54-4.981 4.882-4.981.634 0 1.727.124 2.174.248v2.77a12.853 12.853 0 0 0-1.155-.037c-1.64 0-2.273.621-2.273 2.236v1.08h3.266l-.561 3.056h-2.705v6.87C16.163 19.329 20 15.113 20 10Z"
      />
      <Box
        as="path"
        fill="#fff"
        d="m13.916 13.054.561-3.056h-3.266v-1.08c0-1.615.634-2.237 2.273-2.237.51 0 .92.013 1.155.038v-2.77c-.447-.125-1.54-.249-2.173-.249-3.342 0-4.882 1.578-4.882 4.981v1.317H5.522v3.056h2.062v6.65a10.022 10.022 0 0 0 3.627.22v-6.87h2.705Z"
      />
    </Icon>
  );
}
